import { getRootId } from "./getRootId.js";
function convertOptionsToId(options) {
  return Object.keys(options).sort().filter((key) => options[key] !== void 0).map((key) => {
    const value = key === "root" ? getRootId(options.root) : options[key];
    return `${key}_${value}`;
  }).toString();
}
export {
  convertOptionsToId
};
//# sourceMappingURL=convertOptionsToId.js.map
